<script lang="ts">
import type { SelectRootEmits, SelectRootProps } from 'reka-ui'

import { createContext, SelectRoot, useForwardPropsEmits } from 'reka-ui'

export const [injectSelectContext, provideSelectContext] = createContext<{ hasError: ComputedRef<boolean> }>('Select')
</script>

<script setup lang="ts">
const props = defineProps<SelectRootProps & { hasError?: boolean }>()
const emits = defineEmits<SelectRootEmits>()

const forwarded = useForwardPropsEmits(props, emits)

provideSelectContext({ hasError: computed<boolean>(() => props.hasError ?? false) })
</script>

<template>
  <SelectRoot v-bind="forwarded">
    <slot />
  </SelectRoot>
</template>
